"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withStyles_1 = require("../decorators/withStyles");

var InputGroupCell_1 = require("./InputGroupCell");

var baseProps_1 = require("../assets/baseProps");

var memoize_1 = require("../utils/memoize");

var isInvalid_1 = require("../channels/isInvalid");

var InputGroup =
/** @class */
function (_super) {
  __extends(InputGroup, _super);

  function InputGroup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      hover: null,
      focus: null
    };
    _this.getSetFocus = memoize_1.default(function (index, focus) {
      var _this = this;

      return function (val) {
        /* istanbul ignore else */
        if (val) {
          _this.setState({
            focus: index
          });
        } else if (focus === index) {
          _this.setState({
            focus: null
          });
        }
      };
    }, _this);
    _this.getSetHover = memoize_1.default(function (index, hover) {
      var _this = this;

      return function (val) {
        /* istanbul ignore else */
        if (val) {
          _this.setState({
            hover: index
          });
        } else if (hover === index) {
          _this.setState({
            hover: null
          });
        }
      };
    }, _this); // tslint:disable-next-line:only-arrow-functions

    _this.getDivider = memoize_1.default(function (key, hover, focus, disabled, invalid, secondary) {
      return React.createElement(InputGroupCell_1.default, {
        divider: true,
        key: key,
        child: null,
        hover: hover,
        focus: focus,
        disabled: disabled,
        invalid: invalid,
        secondary: secondary
      });
    });
    return _this;
  }

  InputGroup.prototype.isInputGroupIsInvalid = function () {
    return !!this.props.invalid;
  };

  InputGroup.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        focus = _a.focus,
        hover = _a.hover;
    var _b = this.props,
        classes = _b.classes,
        children = _b.children;
    var childrenArray = React.Children.toArray(children).filter(React.isValidElement);
    var childrenCharacteristics = childrenArray.map(function (child, index) {
      return {
        focus: index === focus || child.props.dangerouslyApplyFocusStyle,
        hover: index === hover || child.props.dangerouslyApplyHoverStyle,
        invalid: child.props.invalid || _this.isInputGroupIsInvalid(),
        disabled: child.props.disabled,
        secondary: child.props.secondary
      };
    });
    var toRender = childrenArray.map(function (child, index) {
      return React.createElement(InputGroupCell_1.default, {
        key: 2 * index,
        first: index === 0,
        last: index === childrenArray.length - 1,
        child: child,
        setFocus: _this.getSetFocus(index, focus),
        setHover: _this.getSetHover(index, hover)
      });
    }).reduce(function (acc, curr, index, array) {
      if (index === array.length - 1) {
        return acc.concat(curr);
      }

      var k = 2 * index + 1;
      var left = childrenCharacteristics[index];
      var right = childrenCharacteristics[index + 1];

      var divider = _this.getDivider(k, left.hover || right.hover, left.focus || right.focus, left.disabled || right.disabled, left.invalid || right.invalid, left.secondary || right.secondary);

      return acc.concat(curr, divider);
    }, []);
    return React.createElement("div", __assign({}, baseProps_1.default(this.props), {
      className: classes.base
    }), toRender);
  };

  InputGroup = __decorate([isInvalid_1.withIsInvalid(isInvalid_1.mapIsInvalidToProps), withStyles_1.withStyles({
    base: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      width: '100%',
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-pack': 'justify',
        '-ms-flex-direction': 'row'
      }, {
        display: '-webkit-box',
        '-webkit-box-pack': 'justify',
        '-webkit-box-orient': 'horizontal',
        '-webkit-box-direction': 'normal'
      }, {
        display: '-webkit-flex',
        '-webkit-justify-content': 'space-between',
        '-webkit-flex-direction': 'row'
      }]
    }
  })], InputGroup);
  return InputGroup;
}(React.Component);

exports.default = InputGroup;